import { createFileRoute } from '@tanstack/react-router';
import { MfaTotpSetup } from '../../components/me/MfaTotpSetup';

export const Route = createFileRoute('/_authenticated/_layout/me/security/mfa-totp-setup')({
    component: () => <MfaTotpSetup />,
});
